import { gql } from '@apollo/client';

// IB-1886: the server derives the Metabase identity from the auth token; no input is sent.
export const METABASE_LOGIN_TOKEN = gql`
  query GetMetabaseLoginToken {
    getMetabaseLoginToken {
      token
    }
  }
`;
